import {Compendium} from 'app/components/promo_action/compendium';
import {inject} from 'mobx-react';

class Enigma extends Compendium {
    static cookieName = 'enigma-menu';
}

export default inject('currentTimeStore')(Enigma);
